import React from "react";

const HandoverIcon = ({ isActive }: any) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_5269_2)">
        <rect x="4" y="4" width="16" height="16.1224" rx="4" fill="#FFE0C1" />
      </g>
      <path
        d="M7.82892 7.875C7.7914 7.87494 7.75536 7.88977 7.72884 7.91634C7.70227 7.94291 7.68739 7.97889 7.6875 8.01647V9.99095C7.68853 10.0683 7.75159 10.1304 7.82892 10.1302H8.67336C8.75068 10.1304 8.81375 10.0683 8.81478 9.99095V9.84948H10.3649C10.4024 9.84959 10.4385 9.83471 10.465 9.80814C10.4915 9.78162 10.5064 9.74559 10.5064 9.70801V9.27094L12.9173 9.00231V9.00237C12.9882 8.99416 13.0418 8.9344 13.0423 8.86312V8.29946C13.0429 8.22727 12.989 8.16626 12.9173 8.15799L10.3792 7.87728C10.3668 7.87557 10.3542 7.87557 10.3418 7.87728L8.81476 8.13268V8.01652C8.81487 7.97895 8.79999 7.94297 8.77342 7.91639C8.7469 7.88982 8.71087 7.875 8.67335 7.87505L7.82892 7.875ZM7.97039 8.15795H8.53183L8.53189 8.29942V9.8494H7.97044L7.97039 8.15795ZM10.3692 8.16017L12.7593 8.42442V8.7365L10.3483 9.00456V9.0045C10.2775 9.01271 10.2239 9.07247 10.2234 9.14381V9.56657L8.8148 9.56651V8.41775L10.3692 8.16017ZM10.9285 10.2716C10.9069 10.2716 10.8857 10.2764 10.8663 10.2859L9.74391 10.8473L9.73843 10.8501V10.8501C9.73347 10.8526 9.72868 10.8554 9.72412 10.8584C9.7215 10.8602 9.71893 10.862 9.71642 10.8639C9.71437 10.8651 9.71232 10.8664 9.71032 10.8677C9.70981 10.8683 9.70924 10.8688 9.70867 10.8694C9.70502 10.8725 9.70154 10.8758 9.69817 10.8793C9.6976 10.8801 9.69709 10.8808 9.69652 10.8815C9.69276 10.8855 9.68928 10.8898 9.68603 10.8941C9.67941 10.9032 9.67388 10.913 9.66955 10.9233C9.66054 10.9451 9.65712 10.9687 9.65963 10.9922V13.5132C9.65951 13.5507 9.67445 13.5867 9.70097 13.6133C9.72754 13.6398 9.76358 13.6547 9.80116 13.6546H12.62C12.6214 13.6544 12.6229 13.6543 12.6244 13.654C12.6269 13.6541 12.6295 13.6541 12.6321 13.654C12.6335 13.6539 12.635 13.6537 12.6365 13.6535C12.6406 13.6529 12.6446 13.6522 12.6486 13.6513C12.6501 13.6509 12.6516 13.6505 12.653 13.6502C12.6624 13.648 12.6717 13.6449 12.6805 13.6409C12.6811 13.6405 12.6817 13.6401 12.6822 13.6397L13.8101 13.0761H13.8101C13.8578 13.0518 13.8876 13.0025 13.8871 12.949V10.4389C13.8942 10.4008 13.8853 10.3614 13.8625 10.3301C13.8397 10.2988 13.805 10.2782 13.7666 10.2732C13.7617 10.2724 13.7567 10.2718 13.7517 10.2715H13.75H13.7478L10.9285 10.2716ZM10.9621 10.5545H13.1462L12.5852 10.8352H10.3978L10.9621 10.5545ZM13.6064 10.6421V12.8621L12.7615 13.2843V11.0621L12.9982 10.9442L13.6064 10.6421ZM9.94272 11.1182H12.4786V13.3712H9.94272V11.1182ZM14.8731 13.7939C14.7958 13.795 14.7337 13.858 14.7338 13.9354V14.0768H13.1837C13.1462 14.0768 13.1101 14.0916 13.0836 14.1182C13.0571 14.1447 13.0422 14.1808 13.0422 14.2183V14.6548L10.6313 14.9234C10.5605 14.9316 10.5068 14.9913 10.5063 15.0627V15.6269C10.5068 15.6982 10.5605 15.758 10.6313 15.7661L13.1672 16.0491C13.1804 16.0502 13.1938 16.0495 13.2068 16.0469L14.7337 15.7936V15.9076C14.7336 15.985 14.7957 16.0481 14.873 16.0491H15.7202C15.7577 16.0491 15.7937 16.0343 15.8202 16.0077C15.8468 15.9812 15.8617 15.9451 15.8616 15.9076V13.9353C15.8617 13.8978 15.8468 13.8618 15.8202 13.8353C15.7937 13.8087 15.7577 13.7938 15.7202 13.7939L14.8731 13.7939ZM15.0146 14.0769H15.5782V15.7663H15.0146V14.0769ZM13.3252 14.3576H14.7338V15.5058L13.1799 15.7662L10.787 15.4998V15.1899L13.1985 14.9213V14.9212C13.2709 14.9137 13.3257 14.8525 13.3251 14.7798L13.3252 14.3576Z"
        fill="#A15000"
      />
      <defs>
        <filter
          id="filter0_d_5269_2"
          x="0"
          y="0"
          width="24"
          height="24.1221"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5269_2"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5269_2"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default HandoverIcon;
